import "./spinner.css";

const Spinner = () => (
  // <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
  //   <div className="relative w-10 h-10 animate-bounce">
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       fill="none"
  //       viewBox="0 0 24 24"
  //       strokeWidth={2}
  //       stroke="currentColor"
  //       className="w-10 h-10 text-blue-500"
  //     >
  //       <path
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //         d="M3 10l11-7 11 7-11 7-11-7zm0 0v4a8 8 0 0016 0v-4"
  //       />
  //     </svg>
  //   </div>
  //   <p className="mt-4 text-gray-600 text-lg font-medium">
  //     Just a moment, we are searching for the flights on this route.
  //   </p>
  // </div>
  <div className="fallback-spinner">
    <div className="loading component-loader">
      <div className="effect-1 effects" />
      <div className="effect-2 effects" />
      <div className="effect-3 effects" />
    </div>
  </div>
);
export default Spinner;
